export default __webpack_public_path__ + "static/media/NLR-10.eb6d78cc.webp";